import { Box } from "@mui/material";
import React, { useEffect } from "react";
import "./view-plan-details.scss";
import ViewCrmPlanDetails from "./view-crm-plan-details/view-crm-plan-details";
import ViewCRMPriceDetails from "./view-crm-price-details.tsx/view-crm-price-details";
import ViewCrmBenefits from "./view-crm-benefits/view-crm-benefits";
import PlanDetails from "../create-new-plan/crm-plan-details/crm-plan-details";
import PriceDetails from "../create-new-plan/crm-price-details/crm-price-detials";
import CRMBenefits from "../create-new-plan/crm-benefits/crm-benefits";
import { useFormikContext } from "formik";
import { updateCRMPlan } from "../../../../api/crm-plans";
import { AlertComponent } from "../../../../common/components";
import { AlertMessage } from "../../tenant-details/tenant-details-types";
import { useSetLoading } from "../../../../common/hooks/appearance";

interface ViewPlanDetailsProps {
  activeTab?: any;
  title: any;
  plans?: any;
  setPlans?: any;
  allPlans?: any;
  onCustomPlanUpdate?:any;
}
const ViewPlanDetails: React.FC<ViewPlanDetailsProps> = ({
  activeTab,
  title,
  plans,
  setPlans,
  allPlans,
  onCustomPlanUpdate,
}) => {
  const [isEditBasic, setIsEditBasic] = React.useState<boolean>(false);
  const [isEditPrice, setIsEditPrice] = React.useState<boolean>(false);
  const [isEditBenefits, setIsEditBenefits] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [alertMessage, setAlertMessage] = React.useState<AlertMessage>({
    open: false,
  });

  const { values, resetForm } = useFormikContext<any>();

  const handleSubmit = async (
    sectionType: "basicDetails" | "pricing" | "benefits",
    payload: any,
    updatePlansData: any
  ) => {
    try {
      setIsLoading(true);

      const res = await updateCRMPlan(values?.id, sectionType, payload);

      const updateAllPlans: any = [...allPlans];
      updateAllPlans[activeTab as keyof typeof updateAllPlans] = {
        ...values,
        ...updatePlansData,
      };

      setPlans([...updateAllPlans]);

      const updatedPlan = { ...values, ...updatePlansData };
      onCustomPlanUpdate?.(updatedPlan);
      setAlertMessage({
        open: true,
        message:
          res?.data?.data?.message || "New plan has been created successfully.",
        type: "success",
      });
      setIsLoading(false);
      if (sectionType === "basicDetails") handleCancel();
      else if (sectionType === "pricing") handleEditCancel();
      else setIsEditBenefits(false);
    } catch (e: any) {
      setIsLoading(false);
      setAlertMessage({
        open: true,
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Some thing went wrong!",
        type: "error",
      });
    }
  };

  const handleCancel = () => {
    resetForm({
      values: {
        ...values,
        planName: plans?.planName,
        themeColor: plans?.themeColor,
        subHeading: plans?.subHeading,
      },
    });
    setIsEditBasic(false);
  };
  const handleEditCancel = () => {
    resetForm({
      values: {
        ...values,
        monthlyPrice: plans?.monthlyPrice,
        annualPrice: plans?.annualPrice,
      },
    });
    setIsEditPrice(false);
  };

  const handleBenefitCancel = () => {
    resetForm({
      values: {
        ...plans,
        notes: plans?.notes ?? "",
        noOfUsers: plans?.noOfUsers ?? "",
        noOfLeads: plans?.noOfLeads ?? "",
        noOfContacts: plans?.noOfContacts ?? "",
        storageLimit: plans?.storageLimit ?? "",
        apiCallsPerMonth: plans?.apiCallsPerMonth ?? "",
        automationRulesLimit: plans?.automationRulesLimit ?? "",
        supportLevel: plans?.supportLevel,
        reportingLevel: plans?.reportingLevel,
      },
    });
    setIsEditBenefits(false);
  };

  useEffect(() => {
    setIsEditBasic(false);
    setIsEditPrice(false);
    setIsEditBenefits(false);
  }, [activeTab]);

  const showLoading = React.useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  return (
    <Box className="view-custom-plan-details-wrapper">
      <Box className="view-plan-price-wrapper" gap={2}>
        <Box className="view-plan-details-wrapper">
          {isEditBasic ? (
            <>
              {" "}
              <PlanDetails
                mode="edit"
                handleCancel={handleCancel}
                setPlans={setPlans}
                activeTab={activeTab}
                handleSubmit={handleSubmit}
                title={title}
              />
            </>
          ) : (
            <ViewCrmPlanDetails
              activeTab={activeTab}
              titile={title}
              setIsEditBasic={setIsEditBasic}
              plans={plans}
            />
          )}
        </Box>
        <Box className="view-plan-price-wrapper">
          {isEditPrice ? (
            <PriceDetails
              mode="edit"
              handleCancel={handleEditCancel}
              handleSubmit={handleSubmit}
            />
          ) : (
            <ViewCRMPriceDetails
              setIsEditPrice={setIsEditPrice}
              plans={plans}
              titile={title}
            />
          )}
        </Box>
      </Box>
      <Box className="view-crm-benefits-wrapprer">
        {isEditBenefits ? (
          <CRMBenefits
            mode="edit"
            handleCancel={handleBenefitCancel}
            handleSubmit={handleSubmit}
          />
        ) : (
          <ViewCrmBenefits
            plans={plans}
            setIsEditBenefits={setIsEditBenefits}
          />
        )}
      </Box>
      {alertMessage?.open && (
        <AlertComponent
          message={alertMessage?.message}
          type={alertMessage?.type || "error"}
          open={alertMessage?.open}
          onClose={() => {
            setAlertMessage({ open: false });
          }}
        />
      )}
    </Box>
  );
};

export default ViewPlanDetails;
